// src/app/redux/sagas/jobSkillSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchJobSkillsRequest,
    fetchJobSkillsSuccess,
    fetchJobSkillsFail,
    createJobSkillSuccess,
    createJobSkillFail,
    updateJobSkillSuccess,
    updateJobSkillFail,
    deleteJobSkillSuccess,
    deleteJobSkillFail,
    importJobSkillsExcelSuccess,
    importJobSkillsExcelFail,
    downloadJobSkillsTemplateSuccess,
    downloadJobSkillsTemplateFail,
    setJobSkillLoading,
} from "../actions/jobSkillActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest, getBlobRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a   = document.createElement("a");
    a.href     = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export function* fetchJobSkillsSaga(action) {
    const { jobId } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/job/${jobId}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchJobSkillsSuccess(resp.data));
    } catch (e) {
        yield put(fetchJobSkillsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* createJobSkillSaga(action) {
    const url   = `${API_BASE_URL}/api/job-skills`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createJobSkillSuccess(resp.data));
        yield put(fetchJobSkillsRequest(action.payload.jobId));
        yield call([Swal, Swal.fire], { icon: "success", text: "Compétence ajoutée au poste", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur ajout compétence", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* updateJobSkillSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateJobSkillSuccess(resp.data));
        yield put(fetchJobSkillsRequest(payload.jobId));
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification niveau", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* deleteJobSkillSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/job-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setJobSkillLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteJobSkillSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Compétence supprimée du poste", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteJobSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression compétence", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setJobSkillLoading(false));
    }
}

export function* downloadJobSkillsTemplateSaga() {
    const token = getToken();
    try {
        const res = yield call(getBlobRequest, {
            url:   `${API_BASE_URL}/api/job-skills/template`,
            token: `Bearer ${token}`,
        });
        downloadBlob(new Blob([res.data]), "template_job_skills.xlsx");
        yield put(downloadJobSkillsTemplateSuccess());
    } catch (e) {
        yield put(downloadJobSkillsTemplateFail(e.response?.data || e.message));
        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template échoué" });
    }
}

export function* importJobSkillsExcelSaga(action) {
    const token = getToken();
    const uid   = getUid();
    const { file, dryRun, action: act, jobId } = action.payload;
    try {
        const fd = new FormData();
        fd.append("file", file);

        const url = `${API_BASE_URL}/api/job-skills/import?dryRun=${dryRun ? "true" : "false"}&action=${act}`;

        const res = yield call(postRequest, { url, data: fd, token, uid });

        yield put(importJobSkillsExcelSuccess(res.data));

        if (!dryRun) {
            Swal.fire({
                icon:  "success",
                title: "Import terminé",
                text:  `${res.data.createdCount} lignes traitées, ${res.data.skippedCount} ignorées`,
            });
            if (jobId) {
                yield put(fetchJobSkillsRequest(jobId));
            }
        } else {
            Swal.fire({
                icon:  "info",
                title: "Prévisualisation",
                text:  `${res.data.createdCount} lignes valides, ${res.data.skippedCount} erreurs`,
            });
        }
    } catch (e) {
        yield put(importJobSkillsExcelFail(e.response?.data || e.message));
        Swal.fire({ icon: "error", title: "Erreur import", text: "Import Excel échoué" });
    }
}